import React, { useState, useEffect } from "react";
import RegisterFormHeader from "./header/RegisterFormHeader";
import RegisterFormStep from "./step/RegisterFormStep";
import { FORM_ERROR } from "final-form";
import { Form as FinalForm, Field } from "react-final-form";
import {
  registerConfirmation,
  sendVerification,
} from "../../../../app/store/actions/registerActions";
import {
  combineValidators,
  composeValidators,
  isRequired,
  matchesField,
  isOneOf,
  hasLengthBetween,
} from "revalidate";
import { Form, Button, Grid, GridColumn, Header } from "semantic-ui-react";
import TextInput from "../../../../app/common/form/TextInput";
import ErrorMessage from "../../../../app/common/form/ErrorMessage";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import RegisterCancel from "./RegisterCancel";
import { metodoVerificacionOptions } from "../../../../app/config/data/options";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import { toast } from "react-toastify";
import {
  normalizeNumero,
  normalizePassword,
} from "../../../../app/util/finalFormUtils";
import { isPasswordImprovedValid } from "../../../../app/util/revalidateUtils";
import {
  LONGITUD_MAXIMA_CODIGO_VERIFICACION,
  LONGITUD_MAXIMA_PASSWORD,
  RECAPTCHA_SITE_KEY,
  TIPO_RECAPTCHA_V3,
} from "../../../../app/infrastructure/appConstants";
import RegisterRecover from "./RegisterRecover";
import CheckboxInput from "../../../../app/common/form/CheckboxInput";
import PropTypes from "prop-types";
import { load } from "recaptcha-v3";
import ListaDocumentoTerminosDatosPersonales from "../../../../app/common/list/ListaDocumentoTerminosDatosPersonales";
import {
  MESSAGE_CODIGO_VERIFICACION_NO_VALIDA,
  MESSAGE_CODIGO_VERIFICACION_REQUERIDO,
} from "../../../../app/util/messageUtils";
import PasswordField from "../../../../app/common/form/PasswordField";
import PasswordConfirmField from "../../../../app/common/form/PasswordConfirmField";

const mapState = (state) => ({
  currentCustomer: state.registerUser.currentCustomer,
});

const actions = {
  registerConfirmation,
  sendVerification,
};

const validate = combineValidators({
  codigoVerificacion: composeValidators(
    isRequired({ message: MESSAGE_CODIGO_VERIFICACION_REQUERIDO }),
    hasLengthBetween(
      LONGITUD_MAXIMA_CODIGO_VERIFICACION,
      LONGITUD_MAXIMA_CODIGO_VERIFICACION
    )({
      message: MESSAGE_CODIGO_VERIFICACION_NO_VALIDA,
    })
  )(),
  password: composeValidators(
    isRequired({ message: "Contraseña es requerido" }),
    isPasswordImprovedValid
  )(),
  confirmPassword: composeValidators(
    isRequired({ message: "La confirmación de la contraseña es requerida" }),
    matchesField("password")({ message: "La contraseña no coincide" })
  )(),
  indicadorAceptacionTerminos: composeValidators(
    isRequired({
      message: "Debe aceptar los términos y condiciones para poder registrarse",
    }),
    isOneOf([true])
  )({ message: "Debe aceptar los términos y condiciones" }),
});

const RegisterConfirmationForm = ({
  currentCustomer,
  registerConfirmation,
}) => {
  const [metodoVerificacion, setMetodoVerificacion] = useState(null);
  const [responseVerificacion, setResponseVerificacion] = useState(null);
  const [
    loadingEnviarCodigoVerificacion,
    setLoadingEnviarCodigoVerificacion,
  ] = useState(false);
  const [disableCodigoVerificacion, setDisableCodigoVerificacion] = useState(
    true
  );
  const [errorMetodoVerificacion, setErrorMetodoVerificacion] = useState({
    show: false,
    message: null,
  });

  const sendCodigoVerificacion = async (e) => {
    e.preventDefault();
    if (metodoVerificacion) {
      try {
        let data = {
          idValidacion: currentCustomer.idValidacion,
          metodoVerificacion: metodoVerificacion,
        };
        setLoadingEnviarCodigoVerificacion(true);
        const response = await sendVerification(data);
        setResponseVerificacion(response.data);
        toast.success(response && response.message);
        setDisableCodigoVerificacion(false);
        setLoadingEnviarCodigoVerificacion(false);
        setErrorMetodoVerificacion({
          show: false,
          message: null,
        });
      } catch (error) {
        setLoadingEnviarCodigoVerificacion(false);
        setDisableCodigoVerificacion(true);
        setErrorMetodoVerificacion({
          show: true,
          message: error.data.message,
        });
      }
    } else {
      setErrorMetodoVerificacion({
        show: true,
        message: "Selecciona un método de verificación",
      });
    }
  };

  const onChangeMetodoVerificacion = (value) => {
    if (value) {
      setMetodoVerificacion(value);
      setErrorMetodoVerificacion({
        show: false,
        message: null,
      });
    }
  };

  // const [activeIndex, setActiveIndex] = useState(1);

  // const handleClickTerminosCondiciones = (e, titleProps) => {
  //   const { index } = titleProps;
  //   const newIndex = activeIndex === index ? -1 : index;

  //   setActiveIndex(newIndex);
  // };

  //reCAPTCHA
  useEffect(() => {
    load(RECAPTCHA_SITE_KEY).then((recaptcha) => {
      recaptcha.execute().then((token) => {
        console.log("reCAPTCHA load success");
      });
    });
  }, []);

  const updateTokenReCaptcha = async () => {
    const recaptcha = await load(RECAPTCHA_SITE_KEY);
    const token = await recaptcha.execute();
    return token;
  };

  return (
    <FinalForm
      onSubmit={async (values) => {
        const recaptcha = await updateTokenReCaptcha();
        return registerConfirmation(
          {
            ...values,
            ...responseVerificacion,
            typeReCaptcha: TIPO_RECAPTCHA_V3,
            recaptcha,
          },
          currentCustomer
        ).catch((error) => ({
          [FORM_ERROR]: error,
        }));
      }}
      validate={validate}
      render={({
        handleSubmit,
        submitting,
        submitError,
        invalid,
        pristine,
        dirtySinceLastSubmit,
        values,
      }) => (
        <Form onSubmit={handleSubmit} error>
          <br />
          <RegisterFormHeader />
          <RegisterFormStep />
          <Header textAlign="center">
            <Header.Subheader>
              Confirmación y Creación de contraseña
            </Header.Subheader>
          </Header>
          <Header
            textAlign="center"
            as="h5"
            content={`Cliente: ${currentCustomer &&
              currentCustomer.nombreCliente}`}
            color="blue"
          />
          <br />
          <Field
            name="metodoVerificacion"
            component={SelectedInput}
            placeholder="Selecciona el método de verificación"
            options={metodoVerificacionOptions}
            handleOnChange={onChangeMetodoVerificacion}
          />
          {errorMetodoVerificacion.show && (
            <ErrorMessage text={errorMetodoVerificacion.message} />
          )}
          <Button
            onClick={sendCodigoVerificacion}
            as={Link}
            to="#"
            fluid
            basic
            color="blue"
            size="small"
            content="Solicitar código de verificación"
            loading={loadingEnviarCodigoVerificacion}
          />
          <br />
          <Header
            textAlign="center"
            as="h5"
            content={`Usuario: ${currentCustomer &&
              currentCustomer.numeroDocumentoCliente}`}
            color="blue"
          />
          <Field
            name="codigoVerificacion"
            component={TextInput}
            placeholder="Ingresa el código de verificación"
            disabled={disableCodigoVerificacion}
            parse={normalizeNumero}
            maxLength={LONGITUD_MAXIMA_CODIGO_VERIFICACION}
          />

          <PasswordField
            name="password"
            placeholder="Ingresa tu contraseña"
            maxLength={64}
          />

          <PasswordConfirmField
            name="confirmPassword"
            placeholder="Confirma tu contraseña"
            maxLength={64}
          />

          <br />
          <Field
            name="indicadorAceptacionTerminos"
            component={CheckboxInput}
            type="checkbox"
            label="Autorizo el uso de mis datos personales según términos y condiciones"
          />

          <ListaDocumentoTerminosDatosPersonales />

          {submitError && !dirtySinceLastSubmit && (
            <ErrorMessage error={submitError} />
          )}
          <br />
          <Grid divided="vertically">
            <Grid.Row columns={2}>
              <GridColumn>
                <RegisterCancel />
              </GridColumn>
              <GridColumn>
                <Button
                  fluid
                  disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                  size="large"
                  loading={submitting}
                  color="yellow"
                  content="Aceptar"
                />
              </GridColumn>
            </Grid.Row>
          </Grid>
          <br />
        </Form>
      )}
    />
  );
};

RegisterConfirmationForm.propTypes = {
  currentCustomer: PropTypes.object.isRequired,
  registerConfirmation: PropTypes.func.isRequired,
};

export default connect(mapState, actions)(RegisterConfirmationForm);
